import React from "react";
import MuiCircularProgress from "@mui/material/CircularProgress";
import MuiButton from "@mui/material/Button";
import MuiSearchIcon from "@mui/icons-material/Search";
import MuiDeleteIcon from "@mui/icons-material/Delete";
import MuiTextField from "@mui/material/TextField";
import MuiFolderOpenIcon from "@mui/icons-material/FolderOpen";
import MuiAutocomplete from "@mui/material/Autocomplete";

// Source
import * as HelperSrc from "../../HelperSrc";
import * as ModelHelperSrc from "../../model/HelperSrc";
import * as ModelPayer from "../../model/custom/Payer";
import ControllerPayerList from "../../controller/custom/PayerList";
import ControllerUserList from "../../controller/UserList";
import ControllerLocalization from "../../controller/Localization";
import ViewLoader from "../Loader";
import ViewPagination from "../Pagination";
import ViewDialog from "../Dialog";

let isRendered = false;

const payerListAutocompleteSlotProps = HelperSrc.createAutocompleteSlotProps("view_list_popper", [0, 0]);

const viewPagePayerList: React.FC<ModelPayer.Iprops> = (props) => {
    // Variable
    const controllerPayerList = new ControllerPayerList(isRendered);
    const controllerUserList = new ControllerUserList(isRendered);
    const controllerLocalization = new ControllerLocalization(isRendered);

    // Method
    controllerPayerList.initializeHook();
    controllerLocalization.initializeHook();

    // Render
    isRendered = true;

    if (
        controllerLocalization.getStorageMain &&
        controllerPayerList.getSelectOption &&
        controllerPayerList.getPagination &&
        controllerPayerList.getFilter &&
        controllerPayerList.getDataMainList
    ) {
        return (
            <div className="view_payer_list" data-at_id="view_payer_list">
                <div className="button_container">
                    {(() => {
                        const html: JSX.Element[] = [];

                        if (HelperSrc.checkRole(controllerUserList.getStorageRole, ["superuser"], props.userData)) {
                            html.push(
                                <MuiButton
                                    className="button_primary"
                                    data-at_id="button_create_payer"
                                    disabled={controllerPayerList.getApiLoadingList.selectOption}
                                    onClick={() => {
                                        controllerPayerList.clickCreate();
                                    }}
                                >
                                    {(() => {
                                        const html: JSX.Element[] = [];

                                        if (controllerPayerList.getApiLoadingList.selectOption) {
                                            html.push(<MuiCircularProgress className="icon_progress" />);
                                        } else {
                                            html.push(<>{controllerLocalization.getStorageMain.create}</>);
                                        }

                                        return html;
                                    })()}
                                </MuiButton>
                            );
                        }

                        return html;
                    })()}
                </div>
                <table>
                    {(() => {
                        const html: JSX.Element[] = [];

                        html.push(
                            <>
                                <colgroup>
                                    <col className="cell id" />
                                    <col className="cell bank_name" />
                                    <col className="cell branch_name" />
                                    <col className="cell client" />
                                    <col className="cell update_date" />
                                    <col className="cell update_by" />
                                    <col className="cell" />
                                </colgroup>
                                <thead className="filter">
                                    <tr className="row filter_action">
                                        <td>
                                            <MuiButton
                                                className="button_primary container_button"
                                                data-at_id="button_apply"
                                                disabled={controllerPayerList.getApiLoadingList.selectOption}
                                                onClick={() => {
                                                    controllerPayerList.clickFilterApply();
                                                }}
                                            >
                                                {(() => {
                                                    const html: JSX.Element[] = [];

                                                    if (controllerPayerList.getApiLoadingList.selectOption) {
                                                        html.push(<MuiCircularProgress className="icon_progress" />);
                                                    } else {
                                                        html.push(
                                                            <span className="button_label">
                                                                {controllerLocalization.getStorageMain.apply} <MuiSearchIcon />
                                                            </span>
                                                        );
                                                    }

                                                    return html;
                                                })()}
                                            </MuiButton>
                                        </td>
                                    </tr>
                                    <tr className="row not_hover">
                                        <th className="cell field_container">{controllerLocalization.getStorageMain.id}</th>
                                        <th className="cell field_container">
                                            <MuiAutocomplete
                                                slotProps={payerListAutocompleteSlotProps}
                                                blurOnSelect
                                                options={(() => {
                                                    const optionList: ModelHelperSrc.IelementOption[] = [{ value: "", display_name: "" }];

                                                    for (const optionData of Object.values(controllerPayerList.getSelectOption.bank_name)) {
                                                        const optionDataTyped = optionData as ModelHelperSrc.IelementOption;

                                                        optionList.push(optionDataTyped);
                                                    }

                                                    return optionList;
                                                })()}
                                                getOptionLabel={(option) => option.display_name}
                                                renderOption={(props, option) => {
                                                    if (controllerLocalization.getStorageMain) {
                                                        return (
                                                            <li {...props}>{option.display_name || controllerLocalization.getStorageMain.select}</li>
                                                        );
                                                    }
                                                }}
                                                isOptionEqualToValue={(opt, val) => String(opt.value) === String(val.value)}
                                                renderInput={(params) => (
                                                    <MuiTextField
                                                        {...params}
                                                        variant="outlined"
                                                        className="field_value"
                                                        name="bank_name"
                                                        label={
                                                            controllerLocalization.getStorageMain
                                                                ? controllerLocalization.getStorageMain.bank_name
                                                                : ""
                                                        }
                                                    />
                                                )}
                                            />
                                        </th>
                                        <th className="cell field_container">
                                            <MuiAutocomplete
                                                slotProps={payerListAutocompleteSlotProps}
                                                blurOnSelect
                                                options={(() => {
                                                    const optionList: ModelHelperSrc.IelementOption[] = [{ value: "", display_name: "" }];

                                                    for (const optionData of Object.values(controllerPayerList.getSelectOption.branch_name)) {
                                                        const optionDataTyped = optionData as ModelHelperSrc.IelementOption;

                                                        optionList.push(optionDataTyped);
                                                    }

                                                    return optionList;
                                                })()}
                                                getOptionLabel={(option) => option.display_name}
                                                renderOption={(props, option) => {
                                                    if (controllerLocalization.getStorageMain) {
                                                        return (
                                                            <li {...props}>{option.display_name || controllerLocalization.getStorageMain.select}</li>
                                                        );
                                                    }
                                                }}
                                                isOptionEqualToValue={(opt, val) => String(opt.value) === String(val.value)}
                                                renderInput={(params) => (
                                                    <MuiTextField
                                                        {...params}
                                                        variant="outlined"
                                                        className="field_value"
                                                        name="branch_name"
                                                        label={
                                                            controllerLocalization.getStorageMain
                                                                ? controllerLocalization.getStorageMain.branch_name
                                                                : ""
                                                        }
                                                    />
                                                )}
                                            />
                                        </th>
                                        <th data-at_id="th_client" className="cell field_container">
                                            <MuiAutocomplete
                                                slotProps={payerListAutocompleteSlotProps}
                                                blurOnSelect
                                                options={(() => {
                                                    const optionList: ModelHelperSrc.IelementOption[] = [{ value: "", display_name: "" }];

                                                    for (const optionData of Object.values(controllerPayerList.getSelectOption.client_id)) {
                                                        const optionDataTyped = optionData as ModelHelperSrc.IelementOption;

                                                        optionList.push(optionDataTyped);
                                                    }

                                                    return optionList;
                                                })()}
                                                getOptionLabel={(option) => option.display_name}
                                                renderOption={(props, option) => {
                                                    if (controllerLocalization.getStorageMain) {
                                                        return (
                                                            <li
                                                                {...props}
                                                                data-at_id={`select_client_${option.display_name ? option.display_name : "select"}`}
                                                            >
                                                                {option.display_name || controllerLocalization.getStorageMain.select}
                                                            </li>
                                                        );
                                                    }
                                                }}
                                                isOptionEqualToValue={(opt, val) => String(opt.value) === String(val.value)}
                                                renderInput={(params) => (
                                                    <div>
                                                        <MuiTextField
                                                            {...params}
                                                            variant="outlined"
                                                            className="field_value"
                                                            label={
                                                                controllerLocalization.getStorageMain
                                                                    ? controllerLocalization.getStorageMain.client
                                                                    : ""
                                                            }
                                                        />
                                                        <input
                                                            type="hidden"
                                                            className="field_value"
                                                            name="client_id"
                                                            data-at_id="input_client"
                                                            defaultValue={controllerPayerList.getElementClientIdValue}
                                                        />
                                                    </div>
                                                )}
                                                onChange={(_, option) => {
                                                    if (option && controllerPayerList.setElementClientIdValue) {
                                                        controllerPayerList.setElementClientIdValue(option.value as string);
                                                    }
                                                }}
                                            />
                                        </th>
                                        <th className="cell field_container">
                                            <MuiAutocomplete
                                                slotProps={payerListAutocompleteSlotProps}
                                                blurOnSelect
                                                options={(() => {
                                                    const optionList: ModelHelperSrc.IelementOption[] = [{ value: "", display_name: "" }];

                                                    for (const optionData of Object.values(controllerPayerList.getSelectOption.latest_update)) {
                                                        const optionDataTyped = optionData as ModelHelperSrc.IelementOption;

                                                        optionList.push(optionDataTyped);
                                                    }

                                                    return optionList;
                                                })()}
                                                getOptionLabel={(option) => option.display_name}
                                                renderOption={(props, option) => {
                                                    if (controllerLocalization.getStorageMain) {
                                                        return (
                                                            <li className="date" {...props}>
                                                                {option.display_name
                                                                    ? HelperSrc.localeFormat(new Date(option.display_name))
                                                                    : controllerLocalization.getStorageMain.select}
                                                            </li>
                                                        );
                                                    }
                                                }}
                                                isOptionEqualToValue={(opt, val) => String(opt.value) === String(val.value)}
                                                renderInput={(params) => (
                                                    <MuiTextField
                                                        {...params}
                                                        variant="outlined"
                                                        className="field_value"
                                                        name="latest_update"
                                                        label={
                                                            controllerLocalization.getStorageMain
                                                                ? controllerLocalization.getStorageMain.latest_update
                                                                : ""
                                                        }
                                                    />
                                                )}
                                            />
                                        </th>
                                        <th className="cell field_container">
                                            <MuiAutocomplete
                                                slotProps={payerListAutocompleteSlotProps}
                                                blurOnSelect
                                                options={(() => {
                                                    const optionList: ModelHelperSrc.IelementOption[] = [{ value: "", display_name: "" }];

                                                    for (const optionData of Object.values(controllerPayerList.getSelectOption.latest_update_by_id)) {
                                                        const optionDataTyped = optionData as ModelHelperSrc.IelementOption;

                                                        optionList.push(optionDataTyped);
                                                    }

                                                    return optionList;
                                                })()}
                                                getOptionLabel={(option) => option.display_name}
                                                renderOption={(props, option) => {
                                                    if (controllerLocalization.getStorageMain) {
                                                        return (
                                                            <li {...props}>{option.display_name || controllerLocalization.getStorageMain.select}</li>
                                                        );
                                                    }
                                                }}
                                                isOptionEqualToValue={(opt, val) => String(opt.value) === String(val.value)}
                                                renderInput={(params) => (
                                                    <div>
                                                        <MuiTextField
                                                            {...params}
                                                            variant="outlined"
                                                            className="field_value"
                                                            label={
                                                                controllerLocalization.getStorageMain
                                                                    ? controllerLocalization.getStorageMain.latest_update_by
                                                                    : ""
                                                            }
                                                        />
                                                        <input
                                                            type="hidden"
                                                            className="field_value"
                                                            name="latest_update_by_id"
                                                            defaultValue={controllerPayerList.getElementLatestUpdateByIdValue}
                                                        />
                                                    </div>
                                                )}
                                                onChange={(_, option) => {
                                                    if (option && controllerPayerList.setElementLatestUpdateByIdValue) {
                                                        controllerPayerList.setElementLatestUpdateByIdValue(option.value as string);
                                                    }
                                                }}
                                            />
                                        </th>
                                        <th className="cell field_container"></th>
                                    </tr>
                                </thead>
                            </>
                        );

                        return html;
                    })()}
                    <tbody data-at_id="tbody_payer_list">
                        {(() => {
                            const html: JSX.Element[] = [];

                            if (controllerPayerList.getApiLoadingList.list) {
                                html.push(
                                    <tr className="row_empty">
                                        <td>
                                            <MuiCircularProgress className="icon_progress" />
                                        </td>
                                    </tr>
                                );
                            } else {
                                if (!controllerPayerList.getPagination || Object.entries(controllerPayerList.getPagination.data).length === 0) {
                                    html.push(
                                        <tr className="empty_state">
                                            <td colSpan={100}>
                                                <MuiFolderOpenIcon className="icon" />
                                                <p>{controllerLocalization.getStorageMain.no_result}</p>
                                            </td>
                                        </tr>
                                    );
                                } else {
                                    for (const [key, data] of Object.entries(controllerPayerList.getDataMainList)) {
                                        const alternateRow = Number(key) % 2 === 1 ? "even" : "";

                                        let clientDisplayName = "";

                                        for (const optionData of Object.values(controllerPayerList.getSelectOption.client_id)) {
                                            if (optionData.value === data.client_id) {
                                                clientDisplayName = optionData.display_name;
                                            }
                                        }

                                        html.push(
                                            <tr
                                                className={`row ${alternateRow}`}
                                                data-at_id={`tr_list_data_${data.id}`}
                                                onClick={(event) => {
                                                    controllerPayerList.clickItem(event, data);
                                                }}
                                            >
                                                <td className="cell">{data.id}</td>
                                                <td className="cell" data-at_id="td_bank_name">
                                                    {data.bank_name}
                                                </td>
                                                <td className="cell">{data.branch_name}</td>
                                                <td className="cell" data-at_id="td_client_name">
                                                    {clientDisplayName}
                                                </td>
                                                <td className="cell">
                                                    {data.latest_update ? HelperSrc.localeFormat(new Date(data.latest_update)) : ""}
                                                </td>
                                                <td className="cell">
                                                    {(() => {
                                                        for (const optionData of Object.values(
                                                            controllerPayerList.getSelectOption.latest_update_by_id
                                                        )) {
                                                            const optionDataTyped = optionData as ModelHelperSrc.IelementOption;

                                                            if (data.latest_update_by_id === optionDataTyped.value) {
                                                                return optionDataTyped.display_name;
                                                            }
                                                        }
                                                    })()}
                                                </td>
                                                <td className="cell center">
                                                    {(() => {
                                                        const html: JSX.Element[] = [];

                                                        if (
                                                            HelperSrc.checkRole(
                                                                controllerUserList.getStorageRole,
                                                                ["superuser", "manager"],
                                                                props.userData
                                                            )
                                                        ) {
                                                            html.push(
                                                                <MuiDeleteIcon
                                                                    data-at_id="icon_delete"
                                                                    className="button_icon"
                                                                    onClick={(event) => controllerPayerList.clickRemove(event, data.id)}
                                                                />
                                                            );
                                                        }

                                                        return html;
                                                    })()}
                                                </td>
                                            </tr>
                                        );
                                    }
                                }
                            }

                            return html;
                        })()}
                    </tbody>
                </table>
                <ViewPagination response={controllerPayerList.getPagination} api={controllerPayerList.apiDataList} />
                <ViewDialog
                    className="payer_remove_dialog"
                    isOpen={controllerPayerList.getIsDialogOpen}
                    isApiLoading={controllerPayerList.getApiLoadingList.removeData}
                    labelConfirm={controllerLocalization.getStorageMain.yes}
                    onClickConfirm={controllerPayerList.clickDialogRemoveConfirm}
                    labelCancel={controllerLocalization.getStorageMain.no}
                    onClickCancel={controllerPayerList.clickDialogRemoveCancel}
                    mode={"alert"}
                    content={controllerLocalization.getStorageMain.delete_record}
                />
            </div>
        );
    } else {
        return <ViewLoader />;
    }
};

export default viewPagePayerList;
